<template>
  <span ref="switch" :class="wrapClasses" @click="_toggle">
    <span :class="innerClasses">
      <slot v-if="currentValue" name="open"></slot>
      <slot v-if="!currentValue" name="close"></slot>
    </span>
  </span>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
import Emitter from '../../mixins/emitter'
const SWITCH_PREFIX_CLASS = `${PREFIX_CLASS}switch`
export default {
  name: 'TSwitch',
  mixins: [Emitter],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      validator (value) {
        return [ 'lg', 'sm', 'xs', '' ].includes(value)
      },
      default: ''
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  computed: {
    wrapClasses () {
      return [
        `${SWITCH_PREFIX_CLASS}`,
        {
          [`${SWITCH_PREFIX_CLASS}--checked`]: this.currentValue,
          [`${SWITCH_PREFIX_CLASS}--disabled`]: this.disabled,
          [`${SWITCH_PREFIX_CLASS}--${this.size}`]: !!this.size,
          [`${SWITCH_PREFIX_CLASS}--round`]: this.rounded
        }
      ]
    },
    innerClasses () {
      return [ `${SWITCH_PREFIX_CLASS}__inner` ]
    },
    prop () {
      let parent = this.$parent
      while (parent && parent.$options && parent.$options.name !== 'TFormItem') {
        parent = parent.$parent
      }
      return (parent && parent.prop) || ''
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    _toggle () {
      if (this.disabled) {
        return false
      }
      const checked = !this.currentValue
      this.currentValue = checked
      this.$emit('change', checked)
      // NOTE: 用于form验证
      this.dispatch('TFormItem', 'g-on-form-change', checked)
    },
    focus() {
      let $switch = this.$refs.switch
      $switch.setAttribute('tabindex', '0')
      $switch.focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/switch/switch.vue